<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {
              step: 0
            }
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {},
        watch: {
            step: function (val) {
                switch(val) {
                    case 3:
                        $('html, body').animate({ scrollTop: $('body').position().top + 220 }, 'slow')
                        break
                    case 4:
                        $('html, body').animate({ scrollTop: $('body').position().top + 415 }, 'slow')
                        break
                }
            }
        },
        /////////////////////////////////////////////////////
        // Mounted
        /////////////////////////////////////////////////////
        mounted() {
            this.step = parseInt(window.top.location.hash.replace('#', ''))
            window.top.addEventListener('hashchange', this.stepchange, false);
        },
        /////////////////////////////////////////////////////
        // Computed
        /////////////////////////////////////////////////////
        computed: {
          assignmentScopeMinutesStart() {
            switch (true) {
              case this.step < 2:
                return 191;
              case (this.step >= 4 && this.step < 5):
                return 1;
              case (this.step >= 5):
                return 2;
              default:
                return 0;
            }
          },
          assignmentScopeMinutesEnd() {
            switch (true) {
              case this.step < 2:
                return 286;
              case (this.step >= 4 && this.step < 5):
                return 2;
              case (this.step >= 5):
                return 4;
              default:
                return 0;
            }
          },
          assignmentScopeConcepts() {
            switch (true) {
              case this.step < 2:
                return 159;
              case (this.step >= 4 && this.step < 5):
                return 1;
              case (this.step >= 5):
                return 2;
              default:
                return 0;
            }
          },
          conceptCountLevel2() {
            switch (true) {
              case this.step < 2:
                return 159;
              case (this.step >= 4 && this.step < 5):
                return 1;
              case (this.step >= 5):
                return 2;
              default:
                return 0;
            }
          },
          conceptCountNumberAndQuantity2() {
            switch (true) {
              case this.step < 2:
                return 26;
              case (this.step >= 4 && this.step < 5):
                return 1;
              case (this.step >= 5):
                return 2;
              default:
                return 0;
            }
          },
          conceptCountDimes() {
            switch (true) {
              case (this.step < 2 || this.step > 3):
                return 1
              default:
                return 0;
            }
          },
          conceptCountNickels() {
            switch (true) {
              case this.step < 2 || this.step > 4:
                return 1
              default:
                return 0;
            }
          },
          dimesChecked () {
            return this.step === 1 || this.step >= 4
          },
          nickelsChecked () {
            return this.step === 1 || this.step > 4
          },
          level2Checked () {
            return this.step === 1 || this.step >= 4
          },
          numberAndQuantity2Checked () {
            return this.step === 1 || this.step >= 4
          }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            broadcastEvent(msg) {
                let event = new CustomEvent('myEvent', {detail: msg})
                window.top.document.dispatchEvent(event)
            },
            goToStep(step) {
              switch (step) {
                case 2:
                  if (this.step === 1) {
                    this.setStep(2)
                  }
                  break;
                case 3:
                  if (this.step === 2) {
                    this.setStep(3)
                  }
                  break;
                case 4:
                  if (this.step === 3) {
                    this.setStep(4)
                  }
                  break
                case 5:
                  if (this.step === 4) {
                    this.setStep(5)
                  }
              }
            },
            nextStep() {
              this.broadcastEvent('next-step')
            },
            nextPage() {
              if (this.step === 5) {
                this.broadcastEvent('next-page')
              }
            },
            setStep(step) {
              this.step = step
              this.broadcastEvent(step)
            },
            stepchange() {
                this.step = parseInt(window.top.location.hash.replace('#', ''))
            }
        }
    }

</script>
